<template>
  <div class="FillInfoAndCreateOrderViewContainer" v-if="good">
    <img :src="good.bannerImage" class="wd100 brd8 mb12"/>
    <span class="boldFont mb12">{{ good.name }} | {{ sku.skuName }}</span>
    <nut-row class="shadow pd16 box colFlex brd8 ft14">
      <nut-row class="colFlex ft14" v-if="good.alwaysNeedName">
        <span>孩子姓名：</span>
        <input class="iceInput " placeholder="可以是昵称" v-model="detail.contactName"/>
      </nut-row>
      <nut-row class="colFlex mt12 ft14"
               v-if="good.alwaysNeedPhone||sku.xuepaiCourseId!=null||sku.xuepaiPlanId!=null">
        <span>开课手机号：</span>
        <input class="iceInput" placeholder="此项必填" v-model="detail.contactPhone"/>
      </nut-row>
      <nut-row class="colFlex mt12 ft14" v-if="sku.expressGood||good.alwaysNeedAddress">
        <span>邮寄地址：</span>
        <textarea class="iceInput" placeholder="地址、收货人、以及收货人电话" v-model="detail.contactAddress"/>
      </nut-row>
      <template v-for="(f,fi) in good.paidForms" :key="`form_${fi}`">
        <nut-row class="colFlex mt12">
          <span>{{ f }}：</span>
          <template v-if="filled">
            <input class="iceInput" disabled v-model="detail.extraPaidInfos[f]"/>
          </template>
          <template v-else>
            <input class="iceInput" placeholder="请输入" v-model="detail[f]"/>
          </template>
        </nut-row>
      </template>
      <nut-row class="lightText ft10 mt10" v-if="!filled">
        <span>信息不可修改，提交前请仔细核对</span>
      </nut-row>
      <nut-row class="bothCenter mt24" v-if="!filled">
        <button class="submitBtn wft ft16 vpd8 brd8" @click="createOrder">立即下单</button>
      </nut-row>
    </nut-row>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "FillInfoAndCreateOrderView",
  components: {},
  data() {
    return {
      goodId: this.$route.params.goodId,
      skuId: this.$route.params.skuId,
      detail: {},
      good: null,
      sku: null,
    }
  },
  methods: {
    createOrder() {
      let host = window.location.protocol + '//' + window.location.host
      this.detail.goodId = this.goodId;
      this.detail.skuId = this.skuId;
      this.detail.redirect = host + '/d/' + this.goodId;
      api.createPayOrder(this.detail)
          .then(ret => {
            window.location.href = ret;
          })
    },
    init() {
      api.getSkuInfo(this.skuId)
          .then(ret => {
            this.good = ret.good;
            this.sku = ret.sku;
          })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.FillInfoAndCreateOrderViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;

  .submitBtn {
    border: none;
    background: #E76A2C;
    width: 240px;
  }

  .iceInput {
    background: #F4F4F4;
    padding: 4px;
    width: 95%;
    border: #dedede 1px solid;
    margin-top: 10px;
  }

  .iceInput::placeholder {
    color: lightgray;
  }

  .iceInput:focus {
    outline: none;
  }
}
</style>